module.exports = __webpack_public_path__ + "static/img/10-5.efe18bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10-5.png
// module id = 2Pao
// module chunks = 1